import { Box, HStack, Text } from '@chakra-ui/react'
import { FC, useEffect, useState } from 'react'

const LEO_LOGO = '/transferir.jpeg'

export type SplashPhase = 'center' | 'fly' | 'done'

export function useSplash(): SplashPhase {
  const [phase, setPhase] = useState<SplashPhase>('center')
  useEffect(() => {
    const t1 = setTimeout(() => setPhase('fly'), 1800)
    const t2 = setTimeout(() => setPhase('done'), 2800)
    return () => {
      clearTimeout(t1)
      clearTimeout(t2)
    }
  }, [])
  return phase
}

interface Props {
  phase: SplashPhase
}

const SplashScreen: FC<Props> = ({ phase }) => {
  if (phase === 'done') return null
  const isCenter = phase === 'center'

  return (
    <>
      {/* Dark overlay */}
      <Box
        position="fixed"
        top={0}
        left={0}
        right={0}
        bottom={0}
        zIndex={9998}
        pointerEvents="none"
        opacity={isCenter ? 1 : 0}
        transition="opacity 0.7s ease 0.1s"
        sx={{
          background:
            'linear-gradient(135deg, #071a0f 0%, #0f5238 55%, #0a3d29 100%)'
        }}
      >
        <Box
          position="absolute"
          top="56%"
          left="50%"
          style={{ transform: 'translateX(-50%)' }}
          textAlign="center"
          opacity={isCenter ? 1 : 0}
          transition="opacity 0.2s ease"
          w="300px"
        >
          <Text
            color="white"
            fontSize="22px"
            fontWeight="800"
            letterSpacing="4px"
            mb={1}
          >
            LEO MADEIRAS
          </Text>
          <Text
            color="whiteAlpha.600"
            fontSize="11px"
            letterSpacing="2.5px"
            textTransform="uppercase"
            mb={6}
          >
            Confirmação de Pedidos
          </Text>
          <HStack justify="center" spacing={3}>
            {[0, 1, 2].map(i => (
              <Box
                key={i}
                w={2}
                h={2}
                borderRadius="full"
                bg="whiteAlpha.800"
                sx={{
                  '@keyframes splashDot': {
                    '0%, 100%': { opacity: 0.25, transform: 'scale(0.7)' },
                    '50%': { opacity: 1, transform: 'scale(1.3)' }
                  },
                  animation: `splashDot 1.4s ease-in-out ${i * 0.28}s infinite`
                }}
              />
            ))}
          </HStack>
        </Box>
      </Box>

      {/* Flying logo */}
      <Box
        position="fixed"
        zIndex={9999}
        pointerEvents="none"
        style={{
          transition: 'all 0.9s cubic-bezier(0.4, 0, 0.2, 1)',
          top: isCenter ? '40%' : '16px',
          left: isCenter ? '50%' : '20px',
          transform: isCenter ? 'translate(-50%, -50%)' : 'none',
          width: isCenter ? '180px' : '32px',
          height: isCenter ? '180px' : '32px'
        }}
        sx={
          isCenter
            ? {
                '@keyframes logoGlow': {
                  '0%, 100%': {
                    filter:
                      'drop-shadow(0 0 12px rgba(255,255,255,0.2)) drop-shadow(0 0 40px rgba(15,82,56,0.5))'
                  },
                  '50%': {
                    filter:
                      'drop-shadow(0 0 24px rgba(255,255,255,0.6)) drop-shadow(0 0 70px rgba(15,82,56,0.8))'
                  }
                },
                animation: 'logoGlow 2.2s ease-in-out infinite'
              }
            : {}
        }
      >
        <img
          src={LEO_LOGO}
          alt="Leo Madeiras"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            borderRadius: isCenter ? '24px' : '6px',
            display: 'block'
          }}
        />
      </Box>
    </>
  )
}

export default SplashScreen
